<script setup>
    import { ref, onMounted, onUnmounted, watch } from 'vue';
    import Button from 'primevue/button';
    import api from '../../lib/serverApi';
    import utils from '../../lib/utils';

    const props = defineProps(['config']);
    const lastValue = ref({
        value: '------',
        status: '',
        moment: ''
    });

    let updateTimer = null;

    function updateData() {
        api.getEntitieValues([props.config.entitieId])
        .then(data => {
            lastValue.value.status = data[0].status;
            lastValue.value.moment = utils.timeToString(data[0].moment);
            if (data[0].status === 'GOOD') lastValue.value.value = data[0].value ? 'ВКЛ' : 'ОТКЛ';
            else data[0].value = '------';
            updateTimer = setTimeout(updateData, props.config.updateIterval);
        })
        .catch(error => {
            lastValue.value.value = 'ERROR';
            lastValue.value.status = error.messag;
            lastValue.value.moment = '------';
        })
    }

    onMounted(() => {
        updateData();
    });

    onUnmounted(() => {
        if (updateTimer) clearTimeout(updateTimer);
    });

    watch(props, updateData);

    async function setSignal(value) {
        await api.setEntitieValue(props.config.entitieId, {
            value: value,
            moment: new Date(),
            status: 'COMMAND'
        });

        updateData();
    }
</script>

<template>
    <div class="card my-2 mx-2 pt-4 pb-3 px-4">
        <div class="flex justify-content-between mb-3">
            <span class="block text-500 font-medium mr-3">{{ config.caption }}</span>
        </div>
        <div class="flex justify-content-center">
            <div class="text-900 font-medium text-xl">{{ lastValue.value }}</div>
        </div>
        <div class="flex justify-content-center pt-2">
            <Button class="mr-2" icon="pi pi-play" severity="danger" label="Вкл" size="small" @click="setSignal(true)" />
            <Button icon="pi pi-power-off" severity="success" label="Откл" size="small" @click="setSignal(false)" />
        </div>
    </div>
</template>
